
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    export class ProductSerialsGrid extends Serenity.EntityGrid<ProductSerialsRow, any> {
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumnsKey() { return 'Workspace.ProductSerials'; }
        protected getDialogType() { return ProductSerialsDialog; }
        protected getIdProperty() { return ProductSerialsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSerialsRow.localTextPrefix; }
        protected getService() { return ProductSerialsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt: Slick.GridOptions = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slickgrid-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }

        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected getButtons() {
            // preserving default New Item button
            var buttons = super.getButtons();
            if (Authorization.hasPermission('Workspace:Publisher')) {
                //buttons.push({
                //    title: 'Generate Keys', cssClass: 'add-button',
                //    onClick: () => {
                //        // we could use EditItem here too, but for demonstration
                //        // purposes we are manually creating dialog this time
                //        var dlg = new Workspace.KeyGenDialog();

                //        // let grid watch for changes to manually created dialog, 
                //        // so when a new item is saved, grid can refresh itself
                //        this.initDialog(dlg);

                //        dlg.loadNewAndOpenDialog();
                //    }
                //});

                buttons.push({
                    title: 'Generate Serial Keys', cssClass: 'add-button',
                    onClick: () => {
                        var dialog = new Workspace.KeyGenAsDialog();
                        this.initDialog(dialog);
                        dialog.loadNewAndOpenDialog();
                    }
                });

                buttons.push({
                    title: 'Activate',
                    cssClass: 'unlock-button',
                    onClick: () => {
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        if (rowKeys.length == 0 || rowKeys.length > 1) {
                            Q.alert("Please select single SerialKey to activate!");
                        } else {
                            var key = this.rowSelection.getSelectedKeys()[0];
                            var Status = ProductSerialsRow.getLookup().items.filter(x => x.Id.toString() == key)[0].Status;
                            if (Status == 3) {
                                Q.alert("SerialKey is already activated!");
                                return;
                            }
                            var serialKey = ProductSerialsRow.getLookup().items.filter(x => x.Id.toString() == key)[0].SerialKey;
                            var dialog = new RecordShield.Workspace.ActivationLogDialog();

                            this.initDialog(dialog);

                            dialog.loadEntityAndOpenDialog(<ActivationLogRow>{
                                SerialKey: serialKey
                            });
                            this.rowSelection.resetCheckedAndRefresh();
                            this.refresh();
                        }
                    }
                });

                buttons.push({
                    title: 'Change Status to Open',
                    cssClass: 'edit-button',
                    onClick: () => {
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        if (rowKeys.length == 0 || rowKeys.length > 1) {
                            Q.alert("Please select single SerialKey to Open!");
                            return;
                        } 
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        var key = this.rowSelection.getSelectedKeys()[0];
                        var entity ;
                        RecordShield.Workspace.ProductSerialsService.Retrieve({
                            EntityId: key
                        }, response => {
                            entity = response.Entity;
                            Q.serviceRequest('Workspace/ProductSerials/UpdateStaus', {
                                EntityId: key,
                                Entity: entity
                            }, (response) => {
                                this.rowSelection.resetCheckedAndRefresh();
                                this.refresh();
                            });
                            });                        
                        

                    }
                });
                buttons.push({
                    title: 'Download Sample Excel',
                    cssClass: 'export-xlsx-button',
                    onClick: () => {
                        debugger;
                        var url = "~/Workspace/ProductSerials/DownloadFileFromServer";
                        Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                    }
                });

                buttons.push({
                    title: 'Update Serialkey From Excel',
                    cssClass: 'export-xlsx-button',
                    onClick: () => {
                        debugger;
                        // open import dialog, let it handle rest
                        var dialog = new ProductSerialExcelImportDialog();
                        dialog.element.on('dialogclose', () => {
                            this.refresh();
                            dialog = null;
                        });
                        dialog.dialogOpen();
                    }
                }); 
            }
            else if (Authorization.hasPermission('Workspace:Distributor')) {
                buttons.push({
                    title: 'Activate',
                    cssClass: 'send-button',
                    onClick: () => {
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        if (rowKeys.length == 0 || rowKeys.length > 1) {
                            Q.alert("Please select single SerialKey to activate!");
                        } else {
                            var key = this.rowSelection.getSelectedKeys()[0];
                            var Status = ProductSerialsRow.getLookup().items.filter(x => x.Id.toString() == key)[0].Status;
                            if (Status == 3)
                            {
                                Q.alert("SerialKey is already activated!");
                                return;
                            }
                            var serialKey = ProductSerialsRow.getLookup().items.filter(x => x.Id.toString() == key)[0].SerialKey;
                            var dialog = new RecordShield.Workspace.ActivationLogDialog();

                            this.initDialog(dialog);

                            dialog.loadEntityAndOpenDialog(<ActivationLogRow>{
                                SerialKey: serialKey
                            });
                            this.rowSelection.resetCheckedAndRefresh();
                            this.refresh();
                        }
                    }
                });

                buttons.push({
                    title: 'Change Status to Open',
                    cssClass: 'send-button',
                    onClick: () => {
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        if (rowKeys.length == 0 || rowKeys.length > 1) {
                            Q.alert("Please select single SerialKey to open!");
                            return;
                        }
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        var key = this.rowSelection.getSelectedKeys()[0];
                        var entity;
                        RecordShield.Workspace.ProductSerialsService.Retrieve({
                            EntityId: key
                        }, response => {
                            entity = response.Entity;
                            Q.serviceRequest('Workspace/ProductSerials/UpdateStaus', {
                                EntityId: key,
                                Entity: entity
                            }, (response) => {
                                this.rowSelection.resetCheckedAndRefresh();
                                this.refresh();
                            });
                        });
                    }
                });
                
            }
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/ProductSerials/ListExcel',
                separator: true
            }));

            buttons.push(RecordShield.Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));

            if (Authorization.hasPermission('Workspace:Publisher') || Authorization.hasPermission('Administration:SupportTeam')) {
               
                buttons.push({
                    title: 'UnBlock From Device',
                    cssClass: 'edit-button',
                    onClick: () => {
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        if (rowKeys.length == 0 || rowKeys.length > 1) {
                            Q.alert("Please select single SerialKey to Unblock!");
                            return;
                        }
                        var rowKeys = this.rowSelection.getSelectedKeys();
                        var key = this.rowSelection.getSelectedKeys()[0];
                        var entity;
                        RecordShield.Workspace.ProductSerialsService.Retrieve({
                            EntityId: key
                        }, response => {
                            entity = response.Entity;
                            Q.serviceRequest('Workspace/ProductSerials/UnblockFromDevice', {
                                EntityId: key,
                                Entity: entity
                            }, (response) => {
                                this.rowSelection.resetCheckedAndRefresh();
                                this.refresh();
                            });
                        });


                    }
                });
            }

            buttons = buttons.slice(1);
            return buttons;
        }

        /**
        * This method is called for all rows
        * @param item Data item for current row
        * @param index Index of the row in grid
        */
        protected getItemCssClass(item: Workspace.ProductSerialsRow, index: number): string {
            let klass: string = "";

            if (item.Status == Modules.Workspace.SerialKeys.KeyStatus.Created)
                klass += " created";
            else if (item.Status == Modules.Workspace.SerialKeys.KeyStatus.Open)
                klass += " open";
            else if (item.Status == Modules.Workspace.SerialKeys.KeyStatus.Activated)
                klass += " activated";
            else if (item.Status == Modules.Workspace.SerialKeys.KeyStatus.Disabled)
                klass += " disabled";
            else if (item.Status == Modules.Workspace.SerialKeys.KeyStatus.Expired)
                klass += " expired";

            return Q.trimToNull(klass);
        }
    }
}